var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              staticClass: "form_border",
              attrs: {
                model: _vm.sourcingLineHeadInfo,
                "label-position": _vm.labelPosition,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { type: "flex", justify: "left" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.historyBack },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.close")))]
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("quoteByLine.sourcing.sourcingNo"),
                            prop: "sourcingNo",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingLineHeadInfo.sourcingNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingLineHeadInfo,
                                  "sourcingNo",
                                  $$v
                                )
                              },
                              expression: "sourcingLineHeadInfo.sourcingNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("quoteByLine.sourcing.subject"),
                            prop: "subject",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingLineHeadInfo.subject,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingLineHeadInfo,
                                  "subject",
                                  $$v
                                )
                              },
                              expression: "sourcingLineHeadInfo.subject",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("quoteByLine.sourcing.applyType"),
                            prop: "applyType",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingLineHeadInfo.applyTypeI18n,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingLineHeadInfo,
                                  "applyTypeI18n",
                                  $$v
                                )
                              },
                              expression: "sourcingLineHeadInfo.applyTypeI18n",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("quoteByLine.sourcing.quotationType"),
                            prop: "quotationType",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingLineHeadInfo.quotationTypeI18n,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingLineHeadInfo,
                                  "quotationTypeI18n",
                                  $$v
                                )
                              },
                              expression:
                                "sourcingLineHeadInfo.quotationTypeI18n",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.createBy"),
                            prop: "createBy",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingLineHeadInfo.createUserName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingLineHeadInfo,
                                  "createUserName",
                                  $$v
                                )
                              },
                              expression: "sourcingLineHeadInfo.createUserName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.createDate"),
                            prop: "createDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              clearable: "",
                              disabled: "",
                            },
                            model: {
                              value: _vm.sourcingLineHeadInfo.createDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingLineHeadInfo,
                                  "createDate",
                                  $$v
                                )
                              },
                              expression: "sourcingLineHeadInfo.createDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("quoteByLine.sourcing.supplierCode"),
                            prop: "supplierCode",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingLineHeadInfo.supplierCodes,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingLineHeadInfo,
                                  "supplierCodes",
                                  $$v
                                )
                              },
                              expression: "sourcingLineHeadInfo.supplierCodes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("quoteByLine.sourcing.applyNo"),
                            prop: "applyNo",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingLineHeadInfo.applyNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingLineHeadInfo,
                                  "applyNo",
                                  $$v
                                )
                              },
                              expression: "sourcingLineHeadInfo.applyNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "线路报价明细", name: "first" } },
                [
                  _c(
                    "ux-grid",
                    {
                      ref: "SourcingLineData",
                      attrs: {
                        data: _vm.SourcingLineData,
                        "keep-source": "",
                        "max-height": "550",
                        "highlight-current-row": "",
                        "show-overflow": "tooltip",
                      },
                    },
                    [
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: _vm.$t("quoteByLine.sourcing.itemNo"),
                          field: "itemSequence",
                          "min-width": "120px",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: _vm.$t("quoteByLine.sourcing.finalSupplier"),
                          field: "supplierName",
                          "min-width": "150",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: _vm.$t("quoteByLine.sourcing.pickupPoint"),
                          field: "pickupPoint",
                          "min-width": "90",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: _vm.$t("quoteByLine.sourcing.dc"),
                          field: "dcName",
                          "min-width": "130",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: _vm.$t("quoteByLine.sourcing.temperature"),
                          field: "temperatureI18n",
                          "min-width": "100",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: _vm.$t(
                            "quoteByLine.sourcing.transportaionMethod"
                          ),
                          field: "transportaionMethodI18n",
                          "min-width": "100",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: _vm.$t(
                            "quoteByLine.sourcing.effectiveBeginDate"
                          ),
                          field: "effectiveBeginDate",
                          "min-width": "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("dateFormatFilter")(
                                        scope.row.effectiveBeginDate,
                                        "YYYY-MM-DD"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: _vm.$t("quoteByLine.sourcing.price"),
                          field: "price",
                          "min-width": "140",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: _vm.$t("quoteByLine.sourcing.currentPrice"),
                          field: "formalPrice",
                          "min-width": "130px",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: _vm.$t("quoteByLine.sourcing.currencyCode"),
                          field: "currencyCode",
                          "min-width": "100",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: "Leadtime",
                          field: "leadTime",
                          "min-width": "130px",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: _vm.$t("apply.estimatedAnnualTotalCost"),
                          field: "estimatedAnnualFee",
                          "min-width": "130px",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: "线路类型",
                          field: "lineType",
                          "min-width": "100",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          sortable: "",
                          resizable: "",
                          title: _vm.$t("quoteByLine.sourcing.remarks"),
                          field: "remarks",
                          "min-width": "100",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: _vm.$t("common.approvalLog"), name: "log" } },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "table",
                      attrs: {
                        data: _vm.auditLog,
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          sortable: "",
                          prop: "operatorName",
                          align: "center",
                          label: _vm.$t("common.OperatorName"),
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          sortable: "",
                          prop: "createDate",
                          align: "center",
                          label: _vm.$t("common.OperationTime"),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("dateFormatFilter")(
                                        scope.row.createDate,
                                        "YYYY-MM-DD HH:mm:ss"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          sortable: "",
                          prop: "action",
                          align: "center",
                          label: _vm.$t("common.PedagogicalOperation"),
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          sortable: "",
                          prop: "comments",
                          align: "center",
                          label: _vm.$t("common.remarks"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }